const state = {
  mails: [],
  latestMailLogsRefresh: 0
};

const getters = {
  getMails: state => state.mails,
  getDeliveryStatus: state => state.mails,
  getLatestMailLogsRefresh: state => state.latestMailLogsRefresh,
};

const actions = {
  refreshMailLogs ({ commit }, ts) {
    commit('refreshMailLogs', ts)
  },

  updateMailDeliveryStatus ({ commit }, { messageID, deliveryStatus }) {
    commit('updateMailDeliveryStatus', { messageID, deliveryStatus })
  },

  setMails({ commit }, { mails }) {
    commit('setMails', { mails });
  },
  async loadMailLogs({ commit }, { processUUID }) {
    if (!processUUID) return [];

    try {
      const token = await this.$auth.getTokenSilently();
      const response = await fetch('/api/mail_logs', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token
        },
        body: JSON.stringify({
          processUUID
        })
      });
      const json = await response.json();
      const mails = json?.data?.mails;

      commit('setMails', { mails });

      return mails;
    } catch (error) {
      console.log(error);
    }
  }
};

const mutations = {
  refreshMailLogs (state, ts) {
    state.latestMailLogsRefresh = ts
  },

  setMails(state, { mails }) {
    state.mails = mails;
  },
  updateMailDeliveryStatus(state, { messageID, deliveryStatus }) {
    const mailIndex = state.mails.findIndex(m => m.messageID === messageID);
    if (mailIndex !== -1) {
      console.log('Store => updateMailDeliveryStatus', deliveryStatus)
      state.mails[mailIndex].deliveryStatus = deliveryStatus;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
